import React from 'react';
import './Features.css';
import GearIcon from '../assets/gear.svg';
import ShieldIcon from '../assets/shield.svg';
import BoltIcon from '../assets/bolt.svg';

const Features = () => {
  return (
    <div className="features-container">
      <h1 className="heading">FEATURES</h1>
      <p className="subheading">Why Thousands Rely on VORTREX AI</p>

      <div className="feature-card">
        <img src={GearIcon} alt="Gear Icon" className="icon" />
        <div>
          <h2 className="feature-title">Self-Custody – You Stay in Control</h2>
          <p className="feature-desc">
            VORTREX Bot is a non-custodial system. It has no access to your wallet. You sign, we execute — funds never move unless you approve. Your assets always remain in your control.
          </p>
        </div>
      </div>

      <div className="feature-card">
        <img src={ShieldIcon} alt="Shield Icon" className="icon" />
        <div>
          <h2 className="feature-title">Smart Trades, Real Profits – 25% to 30% Daily ROI</h2>
          <p className="feature-desc">
            Automated Futures Bot that runs 24/7. It scans orderbooks, places smart entries, and exits with SL/TP protection — profits are tracked live in your dashboard.
          </p>
        </div>
      </div>

      <div className="feature-card">
        <img src={BoltIcon} alt="Bolt Icon" className="icon" />
        <div>
          <h2 className="feature-title">Global Access – Zero KYC, Zero Deposit</h2>
          <p className="feature-desc">
            Activate instantly from anywhere. No ID, no registration, no deposits required. Just connect your wallet and let the bot perform — proof of work, not promises.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Features;
